<template>
  <div class='massLoss-list'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1' ref='searchForm'>
        <el-form-item label='传输类型：'>
          <el-select v-model='searchForm.czName' filterable size='mini' placeholder='请选择传输类型'>
            <el-option label='全部' value=''></el-option>
            <el-option label='入港' value='入港'></el-option>
            <el-option label='装船' value='装船'></el-option>
            <el-option label='发运' value='发运'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='运单编号：'>
          <el-input v-model='searchForm.orderNumber' size='mini'
                    placeholder='请输入运单编号'></el-input>
        </el-form-item>
        <el-form-item label='车架号：'>
          <el-input v-model='searchForm.vinCode' size='mini'
                    placeholder='请输入车架号'></el-input>
        </el-form-item>
        <el-form-item label='港口名称：'>
          <el-input v-model='searchForm.deportName' size='mini' placeholder='请输入港口名称'></el-input>
        </el-form-item>
        <el-form-item label='品牌：'>
          <el-input v-model='searchForm.brand' size='mini' placeholder='请输入品牌'></el-input>
        </el-form-item>
        <el-form-item label='传输状态：'>
          <el-select v-model='searchForm.status' filterable size='mini' placeholder='请选择传输状态'>
            <el-option label='全部' value=''></el-option>
            <el-option label='成功' value='0'></el-option>
            <el-option label='失败' value='1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='传输日期：'>
          <el-date-picker
            v-model='transmissionDate'
            type='daterange'
            align='right'
            unlink-panels
            size='mini'
            range-separator='-'
            format='yyyy-MM-dd'
            value-format='yyyy-MM-dd'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='czName' label='传输类型' align='center' min-width='100' />
          <el-table-column prop='fsTime' label='传输时间' align='center' min-width='200' />
          <el-table-column prop='deportName' label='港口名称' align='center' min-width='100' />
          <el-table-column prop='deportid' label='港口代码' align='center' min-width='100' />
          <el-table-column prop='orderNumber' label='运单编号' align='center' min-width='100' />
          <el-table-column prop='vinCode' label='车架号' align='center' min-width='200' />
          <el-table-column prop='brand' label='品牌' align='center' min-width='100' />
          <el-table-column prop='shipno' label='运输工具' align='center' min-width='100' />
          <el-table-column prop='batchNo' label='航次' align='center' min-width='100' />
          <el-table-column prop='drive' label='船长' align='center' min-width='100' />
          <el-table-column prop='username' label='作业人' align='center' min-width='100' />
          <el-table-column prop='scanDate' label='作业时间' align='center' min-width='200' />
          <el-table-column prop='omId' label='路由ID' align='center' min-width='200' />
          <el-table-column prop='cmd' label='扫描类型' align='center' min-width='100' />
          <el-table-column prop='statusStr' label='传输状态' align='center' min-width='100' />
          <el-table-column prop='remake' label='接口返回信息' align='center' min-width='200'
                           show-overflow-tooltip />
          <el-table-column label='操作' width='120' align='center' fixed='right'>
            <template slot-scope='scope'>
              <el-button size='mini' type='primary' @click='infoClick(scope.row)'>请求报文
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <transmission-management-info ref='transmissionManagementInfoRef' />

    <el-dialog
      title='请求报文'
      :visible.sync='dialogVisible'
      width='400px'
      top='35vh'
      :close-on-click-modal='false'>
      <span>{{ ress }}</span>
      <span slot='footer' class='dialog-footer'>
        <el-button type='primary' size='mini' @click='dialogVisible = false'>关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import TransmissionManagementInfo from './components/info.vue';
  import { transportList } from '@/service/DevOps';

  export default {
    name: 'transmissionManagement',
    components: { TransmissionManagementInfo },
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          }],
        },
        ress: '',
        dialogVisible: false,
        searchForm: {
          czName: '',
          orderNumber: '',
          vinCode: '',
          deportName: '',
          brand: '',
          status: '',
          page: 1,
          rows: 10,
        },
        transmissionDate: [],
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
      };
    },
    mounted() {
      this.getDefaultDate();
      // this.searchBtn();
    },
    methods: {
      getDefaultDate() {
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1)
          .toString()
          .padStart(2, '0');
        const day = date.getDate()
          .toString()
          .padStart(2, '0');
        this.transmissionDate = [`${year}-${month}-${day}`, `${year}-${month}-${day}`];
        this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      },
      infoClick(row) {
        this.ress = row.ress;
        this.dialogVisible = true;
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
        this.getDefaultDate();
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await transportList({
          ...this.searchForm,
          startDate: this.transmissionDate && this.transmissionDate[0] ? this.transmissionDate[0] : '',
          endDate: this.transmissionDate && this.transmissionDate[1] ? this.transmissionDate[1] : '',
        });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        const {
          czName,
          orderNumber,
          vinCode,
          deportName,
          brand,
          status,
        } = this.searchForm;
        const [startDate, endDate] = this.transmissionDate;
        // window.location.href = `${baseUrl}/platform/inter/transportChild/logExportXls?access_token=${token}&czName=${czName}&orderNumber=${orderNumber}&vinCode=${vinCode}&deportName=${deportName}&brand=${brand}&status=${status}&status=${status}&startDate=${startDate || ''}&endDate=${endDate || ''}`;
        window.exportExcelGet('/platform/inter/transportChild/logExportXls', `czName=${czName}&orderNumber=${orderNumber}&vinCode=${vinCode}&deportName=${deportName}&brand=${brand}&status=${status}&status=${status}&startDate=${startDate || ''}&endDate=${endDate || ''}`);
      },
    },
  };
</script>

<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
